import {getAxios} from '../../axiosWithToken'

export const getEventBySlug = slug => getAxios().get(`events/${slug}/`)

export const getAllEvents = () =>
    getAxios().get(`events/`)



// WEBPACK FOOTER //
// /opt/build/repo/src/api/async/events/index.js